import style from './EntityMemberships.module.css';
import { getInvestigateUrl } from '../utils';

import { AD_ENTITY_TYPES } from '@silverfort-nodelibs/common/utils/consts';
import investigateIcon from '../common/Images/investigation_blue.png';

const EntityMemberships = ({ parentGuidData = null, entityGroups = [] }) => {
    return (
        <>
            {parentGuidData && (
                <span>
                    <span className={`${style.title} `}>{'Primary User'}:</span>
                    <div className="text-white text-sf flex items-center">
                        <div
                            className="pl-2 max-w-[300px] overflow-hidden text-ellipsis whitespace-nowrap"
                            title={parentGuidData.parentDisplayName}>
                            {parentGuidData.parentDisplayName}
                        </div>
                        <div className="flex items-center justify-center h-5 w-5 ml-2 mr-1 rounded-2xl bg-sf-dark-200 opacity-70 hover:opacity-100 shadow-[0_3px_3px_0_hsla(0,0%,0%,0.14),0_1px_4px_0_hsla(0,0%,0%,0.12),0_2px_2px_-1px_hsla(0,0%,0%,0.2)]">
                            <a
                                title={'Investigate'}
                                href={getInvestigateUrl(
                                    parentGuidData.parentGuid,
                                    AD_ENTITY_TYPES.USER,
                                    parentGuidData.parentDisplayName
                                )}
                                rel="noopener noreferrer"
                                target="_blank"
                                onClick={(e) => e.stopPropagation()}>
                                <img className="h-3 w-3 " alt="investigate" src={investigateIcon} />
                            </a>
                        </div>
                    </div>
                </span>
            )}

            <span>
                <div className={style.title}>Member of:</div>

                <div className={style.groupsWarper}>
                    {entityGroups.map((g) => (
                        <div className={style.groupWarper} key={g.name}>
                            <div className={style.group}>{g.name}</div>
                        </div>
                    ))}
                </div>
            </span>
        </>
    );
};

export default EntityMemberships;
